export function propertySingular(value: number): string {
    return value === 1 ? 'unidad' : 'unidades';
}
